// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle-" + chunkId + "-" + {"58":"8bdae898eea379d10ad7","485":"9033492ded628ff49096"}[chunkId] + ".js";
};